// extracted by mini-css-extract-plugin
export default {"item":"teacher-item_item__r9C3c","hover":"teacher-item_hover__YnK5n","title":"teacher-item_title__jOuEe","title1":"teacher-item_title1__NDIwP"};